<template>
  <div>
    <!-- v-ripple -->
    <button
      type="button"
      class="btn"
      @click="showModal">
      <div class="rg-btn"
      id="place-search-activator">
      <i aria-hidden="true" class="rg-icon material-icons">search</i>
     </div>
    </button>
    <modal
      v-bind:modal-visible="placeSearchState"
      modal-type="top-sheet"
      modal-Id="placesearch">

      <div slot="toolbar-content" class="place-search-container">
        <i aria-hidden="true"
          :class="searchIconClass"
          class="place-search-icon rg-icon material-icons">{{searchIcon}}</i>
        <input
          autofocus="true"
          ref="placeSearchInput"
          class="place-search-input"
          v-model="search" placeholder="Place Search">
          <!-- v-ripple -->
        <i
          @click="clearInput"
          aria-hidden="true"
          class="
            place-search-icon
            rg-icon
            material-icons">
            backspace</i>
      </div>

      <template slot="body">
          <div class="rg-list"
            id="placeSearchInstructions">
            <div class="rg-list-tile two-line">
              <div class="rg-tile-content">
                <div class="rg-tile-title">Place Search</div>
                <div class="rg-tile-sub-title"
                  v-if="items.length">
                  Select a result to navigate to.
                </div>
                <div class="rg-tile-sub-title"
                  v-else>
                  Enter a place name above.
                </div>
              </div>
            </div>
            <hr class="rg-divider" />
          </div>

          <div class="place-results rg-list">
            <!-- v-ripple -->
            <div
              v-for="(item) in items"
              :key="item.magicKey">
              <a class="rg-list-tile"
                @click="selectLocation(item.magicKey)">
                <div class="rg-tile-content">
                  <div class="rg-tile-title" v-text="item.Description"></div>
                </div>
              </a>
            </div>
          </div>
      </template>
    </modal>
  </div>
</template>
<script>
import axios from 'axios';
import debounce from 'lodash.debounce';
import { toLonLat } from 'ol/proj';
import { point } from '@turf/turf';
import { mapState, mapActions } from 'vuex';
import modal from './modal.vue';


export default {
  name: 'PlaceSearchView',

  components: {
    modal,
  },

  data() {
    return {
      placeSearchState: false,
      search: null,
      errors: [],

      descriptionLimit: 60,
      suggestions: [],
      isLoading: false,
      geocoderURI: 'https://geocode.arcgis.com/arcgis/rest/services/World/GeocodeServer/suggest?f=json&maxSuggestions=10&category=Address,Populated%20Place,Land%20Features,Parks%20and%20Outdoors&',
      // eslint-disable-next-line max-len
      searchExtent: '-139.06,48.30,-114.03,60.00', // BC
      locationDetailsURI: 'https://geocode.arcgis.com/arcgis/rest/services/World/GeocodeServer/findAddressCandidates?'
              + 'f=json&'
              + 'outSR=102100&'
              + 'magicKey=',
    };
  },


  created() {
    this.$bus.$on('modal-close-event', this.closeView);
  },

  beforeDestroy() {
    this.$bus.$off('modal-close-event');
  },

  computed: {
    ...mapState([
      'plumeURL',
    ]),

    items() {
      return this.suggestions.map((entry) => {
        const Description = entry.text.length > this.descriptionLimit
          // eslint-disable-next-line prefer-template
          ? entry.text.slice(0, this.descriptionLimit) + '...'
          : entry.text;
        return Object.assign({}, entry, { Description });
      });
    },

    searchIcon() {
      return this.isLoading ? 'autorenew' : 'search';
    },

    searchIconClass() {
      return this.isLoading ? 'rotate' : '';
    },

    geocoderAPI() {
      return `${this.geocoderURI}&searchExtent=${this.searchExtent}&`;
    },

    locationDetailsAPI() {
      return `${this.locationDetailsURI}`;
    },
  },

  watch: {
    search(val) {
      if (!val) {
        this.suggestions = [];
        return;
      }

      if (val.length === 0) {
        this.suggestions = [];
        return;
      }

      if (val.length <= 3) {
        this.suggestions = [];
        return;
      }

      this.searchForSuggestions(val);
    },

    placeSearchState(val) {
      if (val) this.focusInput();
    },
  },

  methods: {
    ...mapActions([
      'setCoordinates',
    ]),
    // eslint-disable-next-line func-names
    searchForSuggestions: debounce(function (val) {
      // console.log('searchForSuggestions', val);
      // Items have already been requested
      // debounce using isLoading
      // if (this.isLoading) return;

      // set loading to true
      this.isLoading = true;

      axios.get(`${this.geocoderAPI}text=${encodeURI(val)}`)
        .then((res) => {
          const { suggestions } = res.data;
          this.suggestions = suggestions;
        })
        .catch((err) => {
          this.suggestions = [];
          console.log(err);
        })
        .finally(() => {
          this.isLoading = false;
        });
    }, 500),

    selectLocation(magicKey) {
      this.isLoading = true;
      axios.get(this.locationDetailsAPI + magicKey)
        .then((response) => {
          // document.getElementById('map').dispatchEvent( new Event( 'click' ) );
          const { location } = response.data.candidates[0];
          const lonLat = toLonLat([location.x, location.y]);
          this.setCoordinates(point(lonLat));
          console.log('selectLocation :: ', location, lonLat);
          this.$bus.$emit('fly-to', location, response.data.candidates[0].extent);
        })
        .catch((err) => {
          console.log(err);
          // this.errors.push(err);
        })
        .finally(() => {
          this.closeView();
        });
    },

    showModal() {
      this.placeSearchState = true;
    },

    closeView() {
      this.placeSearchState = false;
      this.clearInput();
    },

    clearInput() {
      this.search = null;
      this.suggestions = [];
      this.isLoading = false;
    },

    focusInput() {
      this.$nextTick(() => {
        console.log(this.$refs);
        this.$refs.placeSearchInput.focus();
      });
    },
  },
};

</script>

<style lang="less">
@import "../assets/less/variables.less";

@media (max-width: @xs) {
  .place-search-container {
    flex: 1 1 calc(100% - 44px);
  }

  .modal {
    .rg-toolbar-title,
    .rg-toolbar-title {
      display: none;
    }
  }
}

.place-search-container {
  flex: 1 1 auto;
  display: flex;
  background: #fff;
  padding: 0;
  border-radius: 5px;
  height: 46px;
}

.place-search-icon {
  flex: 0 0 46px;
  color: @rg-background-color !important;
}

.place-search-input {
  height: 46px;
  background: #fff;
  color: @rg-background-color;
  font-size: 18px;
  flex: 1 1 100%;
  &:focus {
    outline: none;
  }
}

.modal-body {
  height: 100%;
  overflow: hidden;
}

.place-results.rg-list {
  height: 100%;
  overflow-y: auto;
  padding-bottom: 64px;
}

@keyframes spin-animation {
  to {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}

.spin:before {
  display: block;
  transform-origin: center center;
  -webkit-backface-visibility: hidden;
  animation: spin-animation 2s linear infinite;
}

.rotate {
  transform-origin: center center;
  -webkit-backface-visibility: hidden;
  animation: spin-animation 2s linear infinite;
}
</style>
